export default function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./packages/element/node_modules/d3-array/src/descending.js
// module id = 101
// module chunks = 0